
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/contact-us",
      function () {
        return require("private-next-pages/company/contact-us/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/contact-us"])
      });
    }
  